import { notifyError } from "../Components/notify/notify-component";
import globals from "../Globals.json";
import api from "./api";

export const createStockLocal = (objStockLocal: any) => {
  if (objStockLocal.uuid) {
    return api
      .put(`${globals.api.stocks}/${objStockLocal.uuid}`, objStockLocal)
      .then((res: any) => {
        if (res.status === 201 || res.status === 200) {
          const objCallback = {
            data: res.data.data,
            status: true,
          };
          return objCallback;
        }
      })
      .catch((error: any) => {
        notifyError(error);
      });
  } else {
    return api
      .post(`${globals.api.stocks}`, objStockLocal)
      .then((res: any) => {
        if (res.status === 201 || res.status === 200) {
          const objCallback = {
            data: res.data.data,
            status: true,
          };
          return objCallback;
        }
      })
      .catch((error: any) => {
        notifyError(error);
      });
  }
};

export const getStocks = (store_id: number) => {
  return api.get(`${globals.api.stocks}?paginate=false&store_id=${store_id}`);
};

export const getStocksByStoreId = (store_id?: number) => {
  return api.get(
    `${globals.api.stocks}?paginate=false&filter[store_id]=${store_id}`,
  );
};

export const showStocks = (uuid: string) => {
  return api.get(`${globals.api.stocks}/${uuid}`);
};
